function number(value, decimal = 0) {
  let n = value

  if (typeof n === 'string') {
    n = parseFloat(n)
  }

  if (Number.isFinite(n)) {
    return n.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
  }
}

function currency(value, decimal) {
  const n = number(value, decimal)

  return n ? `$${n}` : n
}

function aprRange(min, max) {
  const aprMin = parseFloat(min),
    aprMax = parseFloat(max)

  if (isNaN(aprMax) || isNaN(aprMin)) {
    return
  }

  if (aprMin === aprMax) {
    return `${number(aprMin, 2)}%`
  }

  return `${number(aprMin, 2)}% - ${number(aprMax, 2)}%`
}

function apr(apr) {
  const n = number(apr, 2)

  return n ? `${n}%` : n
}

function month(months) {
  const n = parseInt(months)

  if (!n) {
    return
  }

  return `${n} ${n == 1 ? 'month' : 'months'}`
}

function balance(fixed, percent) {
  const fixedValue = parseFloat(fixed),
    percentValue = parseFloat(percent)

  if (percentValue) {
    return `${number(percentValue)}%`
  }

  if (fixedValue) {
    return currency(fixedValue)
  }
}

function defaultValue(value, defaultValue) {
  return value || defaultValue
}

function slugify(str) {
  return str
    .toString()                   // Cast to string (optional)
    .normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
    .toLowerCase()                // Convert the string to lowercase letters
    .trim()                       // Remove whitespace from both sides of a string (optional)
    .replace(/\s+/g, '-')         // Replace spaces with -
    .replace(/[^\w\-]+/g, '')     // Remove all non-word chars
    .replace(/\_/g,'-')           // Replace _ with -
    .replace(/\-\-+/g, '-')       // Replace multiple - with single -
    .replace(/\-$/g, '')          // Remove trailing -
    .replace(/^\-/g, '')          // Remove trailing -
}

function ssn(value, masked) {
  const n = value?.replace?.(/\D/g, '')

  if (masked) {
    return n && n.replace(/(\d{3})(\d{2})(\d{4})/, 'xxx-xx-$3')
  }

  return n && n.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3')
}

export {
  number,
  currency,
  aprRange,
  apr,
  month,
  balance,
  defaultValue,
  slugify,
  ssn
}
